import { NotImplementedContainer } from './container';

export const NotImplementedRoute = NotImplementedContainer;
